import { useEffect, useState } from "react";
import { Table } from "reactstrap";
import { Pageable } from "../../../types/common";
import { IPositionTitleInfo } from "../../../types/position";
import { Action } from "../../../types/reducer-action";
import { DataEntryEvent } from "../../common/data-entry-reducer";
import { CheckIcon, CloseIcon } from '../../common/icons';
import PaginationBar from "../../common/pagination-bar";
import TableHeaders, { TableHeaderInfo } from "../../common/table-header";
import TableRow from "../../common/table-row";
import { usePositionTitleDispatch, usePositionTitleState } from "./position-manager-context";
import './style.scss';

const TABLE_HEADERS: TableHeaderInfo<IPositionTitleInfo>[] = [
  { header: 'Position/Role Title', accessor: 'positionName', presorted: 'asc' },
  { header: 'Status', accessor: 'status', sortable: true, cssClass: "column-9rem" }
];

const PositionTitleResultsTable = (props: Pageable) => {
  const { pageSize = 10 } = props;

  const { dataSet, selectedDataId } = usePositionTitleState();
  const dispatch = usePositionTitleDispatch();

  const [sortedData, setSortedData] = useState<IPositionTitleInfo[]>([]);
  const [pagedData, setPagedData] = useState<IPositionTitleInfo[]>([]);

  const selectItem = (item?: IPositionTitleInfo) => dispatch(new Action(DataEntryEvent.SelectData, item?.positionTitleId));

  useEffect(() => {
    selectItem(pagedData.find(item => item.positionTitleId === selectedDataId))
  }, [pagedData, selectedDataId]);

  return (
    <section aria-label="Position/role titles">
      <Table id="positions_table" striped hover className="fixed">
        <TableHeaders headers={TABLE_HEADERS} sortableData={dataSet} onSort={setSortedData} />

        {dataSet && dataSet.length > 0
          ?
          <tbody>
            {pagedData.map((item) =>
              <TableRow key={item.positionTitleId} className={item.displayOrder < 0 ? 'row-pinned' : undefined}
                selected={item.positionTitleId === selectedDataId} onSelect={() => selectItem(item)}>
                <td className="position-name">{item.positionName}</td>
                <td className="position-status">{item.status ? <><CheckIcon /> Active</> : <><CloseIcon /> Inactive</>}</td>
              </TableRow>
            )}
          </tbody>
          :
          <tfoot>
            <tr>
              <td colSpan={TABLE_HEADERS.length} className="text-center">
                {dataSet?.length === 0
                  ? "Sorry, we couldn't find any results matching your search criteria."
                  : 'Search results will appear in this table.'
                }
              </td>
            </tr>
          </tfoot>
        }
      </Table>

      <PaginationBar data={sortedData} pageSize={pageSize} onPageChange={setPagedData} />
    </section>
  );
};

export default PositionTitleResultsTable;
